import DossierFeedbackReviewRepositoryInterface, {
  ReviewCategoryInterface,
} from '@/services/Dossier/review/interfaces';
import { AxiosInstance } from 'axios';

export default class DossierFeedbackReviewRepository implements DossierFeedbackReviewRepositoryInterface {
  constructor(
    private readonly axios: AxiosInstance,
  ) {
  }

  public async getReviewCategories(): Promise<ReviewCategoryInterface[]> {
    const response = await this.axios.get('/dossier-controller/review-categories');

    return response.data;
  }

  public async createReviewCategory(name: string): Promise<ReviewCategoryInterface> {
    const response = await this.axios.post('/dossier-controller/review-categories', { name });

    return response.data;
  }
}
